"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _core = require("@material-ui/core");
var _AddedGiftCard = _interopRequireDefault(require("./components/AddedGiftCard"));
var _GiftCardInformationForm = _interopRequireDefault(require("./components/GiftCardInformationForm"));
var _index = _interopRequireDefault(require("./index.style"));
var _Button = _interopRequireDefault(require("../Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GiftCards = props => {
  const classes = (0, _index.default)();
  const {
    className,
    errorHandler,
    setNoErrors,
    handleApplyGiftCardApiCall,
    handleRemoveGiftCard,
    dictionaries,
    updateGiftCards,
    disableApplyGiftCard,
    disabledGiftCard,
    ...others
  } = props;
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  const [addAnotherGiftCard, setAddAnotherGiftCard] = (0, _react.useState)(true);
  const [giftCards, setGiftCards] = (0, _react.useState)([]);
  const [submitApplyGiftCardRef, setSubmitApplyGiftCardRef] = (0, _react.useState)(null);
  const handleFormChange = _ref => {
    let {
      card,
      errors
    } = _ref;
    if (setNoErrors) {
      if (!card.error && Object.keys(errors).length === 0) {
        setNoErrors(true);
      }
      setNoErrors(false);
    }
  };
  const messages = {
    applied: dictionaries.giftCardBalanceApplied,
    addAnother: dictionaries.giftCardBalanceAppliedAddAnother
  };
  const handleSubmitApplyGiftCardRef = submitApplyGiftCardRefVar => {
    setSubmitApplyGiftCardRef(submitApplyGiftCardRefVar);
  };
  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const handleApplyGiftCard = () => {
    submitApplyGiftCardRef.current.handleSubmit();
  };
  const addGiftCardHandler = () => {
    setAddAnotherGiftCard(!addAnotherGiftCard);
  };
  const removeGiftCardHandler = cardNumber => {
    const giftCardsArray = handleRemoveGiftCard(cardNumber);
    setGiftCards(giftCardsArray);
    if (giftCardsArray.length === 0) {
      setAddAnotherGiftCard(true);
    }
  };
  (0, _react.useEffect)(() => {
    if (disabledGiftCard) {
      setIsExpanded(false);
    }
  }, [disabledGiftCard]);
  (0, _react.useEffect)(() => {
    if (updateGiftCards && updateGiftCards.length > 0) {
      setGiftCards(updateGiftCards);
    }
  }, [updateGiftCards]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)(classes.root, className)
  }, others), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.option
  }, /*#__PURE__*/_react.default.createElement(_core.Accordion, {
    expanded: isExpanded,
    onChange: () => handleExpand(),
    "data-testid": "accordion-giftCard-test"
  }, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
    "data-testid": "expand",
    expandIcon: isExpanded ? /*#__PURE__*/_react.default.createElement(_Remove.default, null) : /*#__PURE__*/_react.default.createElement(_Add.default, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header",
    disabled: disabledGiftCard
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.title
  }, dictionaries.applyRoyalGiftCardTitle)), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.wrapper, isExpanded && classes.expanded)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.subTitle
  }, dictionaries.applyRoyalGiftCardSubTitle), giftCards.map((info, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: info.cardNumber
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.separator
    }), /*#__PURE__*/_react.default.createElement(_AddedGiftCard.default, {
      messages: messages,
      addGiftCardHandler: addGiftCardHandler,
      info: info,
      removeGiftCardHandler: removeGiftCardHandler,
      lastGiftCard: index === giftCards.length - 1,
      dictionaries: dictionaries
    }));
  }), addAnotherGiftCard && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.separator
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.giftCardForm
  }, /*#__PURE__*/_react.default.createElement(_GiftCardInformationForm.default, {
    onFormChange: handleFormChange,
    handleSubmitForm: submitApplyGiftCardRefVar => {
      handleSubmitApplyGiftCardRef(submitApplyGiftCardRefVar);
    },
    giftCards: giftCards,
    setGiftCards: setGiftCards,
    errorHandler: errorHandler,
    setAddAnotherGiftCard: setAddAnotherGiftCard,
    handleApplyGiftCardApiCall: handleApplyGiftCardApiCall,
    dictionaries: dictionaries
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleApplyGiftCard,
    "data-testid": "submit-apply-giftcard",
    className: classes.submitApplyBtn,
    type: "submit",
    disabled: disableApplyGiftCard,
    variant: "contained",
    color: "primary",
    disableRipple: true
  }, dictionaries.applyGiftCard))))))));
};
var _default = exports.default = GiftCards;